export default __webpack_public_path__ + "static/media/DEG.2b52ac8d.jpg";